import { DocumentViewerComponent } from './document-viewer.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule],
    declarations: [DocumentViewerComponent],
    exports: [DocumentViewerComponent]
})
export class NgxDocViewerModule { }